// app/javascript/elements/share_modal.js
// Interactive client controller for the global Share Dialog (Pencil Frames UtWMt & B0qdtw)

(function () {
  let currentAsset = null
  const selectedUserIds = new Set()
  let pendingRevokeGrantId = null
  let cachedEligibleUsers = []

  function getCsrfToken () {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }

  function getHeaders () {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': getCsrfToken()
    }
  }

  function escapeHtml (str) {
    if (!str) return ''
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
  }

  function getInitials (name, email) {
    if (name && name.trim().length > 0) {
      const parts = name.trim().split(/\s+/)
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase()
      }
      return parts[0][0].toUpperCase()
    }
    return (email ? email[0] : '?').toUpperCase()
  }

  function showToast (message, type = 'success') {
    let toastContainer = document.getElementById('doccu_global_toast')
    if (!toastContainer) {
      toastContainer = document.createElement('div')
      toastContainer.id = 'doccu_global_toast'
      toastContainer.className = 'fixed top-6 left-1/2 -translate-x-1/2 z-[99999] pointer-events-none transition-all duration-300'
      document.body.appendChild(toastContainer)
    }

    const isSuccess = type === 'success'
    const bgClass = isSuccess ? 'bg-[#01d680] text-[#043f42] border border-[#01d680]' : 'bg-[#dc2626] text-white border border-[#dc2626]'
    const icon = isSuccess
      ? '<svg class="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>'
      : '<svg class="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>'

    toastContainer.innerHTML = `
      <div class="flex items-center gap-2 px-5 py-2.5 rounded-full shadow-xl font-['Raleway'] font-bold text-[13px] ${bgClass}">
        ${icon}
        <span>${escapeHtml(message)}</span>
      </div>
    `
    toastContainer.style.opacity = '1'
    toastContainer.style.transform = 'translate(-50%, 0)'

    setTimeout(() => {
      if (toastContainer) {
        toastContainer.style.opacity = '0'
        toastContainer.style.transform = 'translate(-50%, -10px)'
      }
    }, 3500)
  }

  window.openShareModal = function (assetData) {
    currentAsset = assetData // { assetType: 'Template'|'Cohort'|'Folder', assetId: 123, assetName: 'Title' }
    selectedUserIds.clear()
    cachedEligibleUsers = []

    const modal = document.getElementById('global_share_modal')
    if (!modal) return

    const titleEl = document.getElementById('share_modal_asset_title')
    if (titleEl) {
      titleEl.textContent = assetData.assetName ? `— ${assetData.assetName}` : ''
    }

    updateSubmitButton()
    if (!modal.open) {
      modal.showModal()
    }
    fetchGrants()
    fetchEligibleUsers()
  }

  function updateSubmitButton () {
    const submitBtn = document.getElementById('share_grant_submit_btn')
    const countBadge = document.getElementById('share_selected_count_badge')
    if (!submitBtn) return

    const count = selectedUserIds.size
    if (count > 0) {
      submitBtn.disabled = false
      submitBtn.textContent = count > 1 ? `Grant access (${count})` : 'Grant access'
      if (countBadge) {
        countBadge.textContent = `${count} selected`
        countBadge.classList.remove('hidden')
      }
    } else {
      submitBtn.disabled = true
      submitBtn.textContent = 'Grant access'
      if (countBadge) {
        countBadge.classList.add('hidden')
      }
    }
  }

  function fetchGrants () {
    if (!currentAsset) return

    const listEl = document.getElementById('share_modal_access_list')
    if (!listEl) return

    listEl.innerHTML = '<div class="text-xs text-[#043f42aa] py-2">Loading access list...</div>'

    fetch(`/api/asset_accesses?asset_type=${encodeURIComponent(currentAsset.assetType)}&asset_id=${encodeURIComponent(currentAsset.assetId)}`, {
      headers: getHeaders()
    })
      .then(res => res.json())
      .then(data => {
        renderAccessList(data)
      })
      .catch(err => {
        console.error('Failed to load asset accesses', err)
        listEl.innerHTML = '<div class="text-xs text-red-500 py-2">Failed to load permissions list.</div>'
      })
  }

  function renderAccessList (data) {
    const listEl = document.getElementById('share_modal_access_list')
    const addSection = document.getElementById('share_modal_add_section')
    if (!listEl) return

    const canManage = data.can_manage
    const owner = data.owner
    const grants = data.grants || []

    if (addSection) {
      addSection.style.display = canManage ? 'flex' : 'none'
    }

    let html = ''

    // 1. Owner Row
    if (owner) {
      const ownerInitials = getInitials(owner.name, owner.email)
      html += `
        <div class="flex items-center justify-between py-1.5 px-2.5 rounded-lg bg-[#f5fefe] border border-[#043f4211]">
          <div class="flex items-center gap-2.5 min-w-0">
            <div class="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-xs shrink-0" style="background-color: ${escapeHtml(owner.avatar_color || '#01d680')}">
              ${escapeHtml(ownerInitials)}
            </div>
            <div class="flex flex-col min-w-0">
              <span class="text-sm font-medium text-[#043f42] truncate max-w-[150px] sm:max-w-none">${escapeHtml(owner.name)}</span>
              <span class="text-xs text-[#043f4288] truncate max-w-[150px] sm:max-w-none">${escapeHtml(owner.email)}</span>
            </div>
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <span class="text-[10px] font-semibold text-white bg-[#043f42] px-2.5 py-0.5 rounded-full">Owner</span>
          </div>
        </div>
      `
    }

    // 2. Collaborator Rows
    if (grants.length === 0) {
      html += `
        <div class="text-xs text-[#043f4288] italic py-2 px-2">
          No one else has access yet.
        </div>
      `
    } else {
      grants.forEach(grant => {
        const initials = getInitials(grant.name, grant.email)

        let roleControl = `
          <span class="text-[10px] font-semibold uppercase px-2 py-0.5 rounded-full bg-[#043f4215] text-[#043f42]">${escapeHtml(grant.role || 'viewer')}</span>
        `
        if (canManage) {
          roleControl += `
              <button type="button" class="share-revoke-btn text-[#043f4288] hover:text-red-600 hover:bg-red-50 p-1 rounded-full transition-colors cursor-pointer" data-grant-id="${escapeHtml(grant.id)}" data-user-name="${escapeHtml(grant.name)}" title="Remove access">
                <svg class="w-4 h-4 pointer-events-none" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            `
        }

        html += `
            <div class="flex items-center justify-between py-1.5 px-2.5 rounded-lg bg-white hover:bg-[#f5fefe] border border-[#043f4211] transition-colors" id="share_grant_row_${escapeHtml(grant.id)}">
            <div class="flex items-center gap-2.5 min-w-0">
              <div class="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-xs shrink-0" style="background-color: ${escapeHtml(grant.avatar_color || '#3b82f6')}">
                ${escapeHtml(initials)}
              </div>
              <div class="flex flex-col min-w-0">
                <span class="text-sm font-medium text-[#043f42] truncate max-w-[150px] sm:max-w-none">${escapeHtml(grant.name)}</span>
                <span class="text-xs text-[#043f4288] truncate max-w-[150px] sm:max-w-none">${escapeHtml(grant.email)}</span>
              </div>
            </div>
            <div class="flex items-center gap-2 shrink-0">
              ${roleControl}
            </div>
          </div>
        `
      })
    }

    listEl.innerHTML = html
  }

  function fetchEligibleUsers () {
    if (!currentAsset) return

    const eligibleListEl = document.getElementById('share_eligible_users_list')
    if (!eligibleListEl) return

    eligibleListEl.innerHTML = '<div class="text-xs text-[#043f42aa] py-2 px-1">Loading available members...</div>'

    fetch(`/api/asset_accesses/eligible_users?asset_type=${encodeURIComponent(currentAsset.assetType)}&asset_id=${encodeURIComponent(currentAsset.assetId)}`, {
      headers: getHeaders()
    })
      .then(res => res.json())
      .then(users => {
        cachedEligibleUsers = Array.isArray(users) ? users : []
        renderEligibleUsers(cachedEligibleUsers)
      })
      .catch(err => {
        console.error('Failed to load eligible users', err)
        eligibleListEl.innerHTML = '<div class="text-xs text-red-500 py-2 px-1">Failed to load member list.</div>'
      })
  }

  function renderEligibleUsers (users) {
    const eligibleListEl = document.getElementById('share_eligible_users_list')
    if (!eligibleListEl) return

    if (!users || users.length === 0) {
      eligibleListEl.innerHTML = `
        <div class="text-xs text-[#043f4288] italic py-3 px-2 bg-[#f5fefe] rounded-[10px] border border-[#043f4211]">
          All account members already have access.
        </div>
      `
      return
    }

    let html = ''
    users.forEach(user => {
      const initials = getInitials(user.name, user.email)
      const isSelected = selectedUserIds.has(user.id)
      const cardClass = isSelected
        ? 'bg-[#f0fdf9] border-[#01d680] shadow-sm'
        : 'bg-[#f5fefe] border-[#043f421a] hover:border-[#043f4244]'

      html += `
        <div class="share-user-select-card flex items-center justify-between p-2 rounded-[12px] border cursor-pointer transition-all ${cardClass}" data-user-id="${escapeHtml(user.id)}">
          <div class="flex items-center gap-2.5 min-w-0 pointer-events-none">
            <div class="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-xs shrink-0" style="background-color: ${escapeHtml(user.avatar_color || '#3b82f6')}">
              ${escapeHtml(initials)}
            </div>
            <div class="flex flex-col min-w-0">
              <span class="text-xs font-semibold text-[#043f42] truncate max-w-[150px] sm:max-w-none">${escapeHtml(user.name)}</span>
              <span class="text-[11px] text-[#043f4288] truncate max-w-[150px] sm:max-w-none">${escapeHtml(user.email)}</span>
            </div>
          </div>
          <div class="flex items-center gap-2 shrink-0 pointer-events-none">
            <span class="text-[10px] font-semibold uppercase px-2 py-0.5 rounded-full bg-[#043f4215] text-[#043f42]">${escapeHtml(user.role || 'viewer')}</span>
            <div class="w-5 h-5 rounded-md border flex items-center justify-center transition-colors ${isSelected ? 'bg-[#01d680] border-[#01d680] text-white' : 'border-[#043f4244] bg-white'}">
              ${isSelected ? '<svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>' : ''}
            </div>
          </div>
        </div>
      `
    })

    eligibleListEl.innerHTML = html
  }

  function openRevokeModal (grantId, userName) {
    pendingRevokeGrantId = grantId
    const nameEl = document.getElementById('revoke_modal_user_name')
    if (nameEl) nameEl.textContent = userName

    const revokeModal = document.getElementById('global_revoke_share_modal')
    if (revokeModal) revokeModal.showModal()
  }

  function executeRevoke () {
    if (!pendingRevokeGrantId) return

    const confirmBtn = document.getElementById('share_confirm_revoke_btn')
    if (confirmBtn) {
      confirmBtn.disabled = true
      confirmBtn.textContent = 'Removing...'
    }

    fetch(`/api/asset_accesses/${pendingRevokeGrantId}`, {
      method: 'DELETE',
      headers: getHeaders()
    })
      .then(async res => {
        if (!res.ok) {
          const body = await res.json().catch(() => ({}))
          throw new Error(body.error || (body.errors && body.errors.join(', ')) || 'Revoke failed')
        }
        return res.json()
      })
      .then(() => {
        const revokeModal = document.getElementById('global_revoke_share_modal')
        if (revokeModal) revokeModal.close()
        pendingRevokeGrantId = null
        fetchGrants()
        fetchEligibleUsers()
        showToast('Access revoked successfully', 'success')
      })
      .catch(err => {
        console.error('Failed to revoke access', err)
        showToast(`Failed to revoke access: ${err.message}`, 'error')
      })
      .finally(() => {
        if (confirmBtn) {
          confirmBtn.disabled = false
          confirmBtn.textContent = 'Revoke'
        }
      })
  }

  function executeGrant () {
    if (selectedUserIds.size === 0 || !currentAsset) return

    const count = selectedUserIds.size
    const submitBtn = document.getElementById('share_grant_submit_btn')
    if (submitBtn) {
      submitBtn.disabled = true
      submitBtn.textContent = 'Granting...'
    }

    fetch('/api/asset_accesses', {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        asset_type: currentAsset.assetType,
        asset_id: currentAsset.assetId,
        user_ids: Array.from(selectedUserIds)
      })
    })
      .then(async res => {
        if (!res.ok) {
          const body = await res.json().catch(() => ({}))
          throw new Error(body.error || (body.errors && body.errors.join(', ')) || 'Grant failed')
        }
        return res.json()
      })
      .then(() => {
        selectedUserIds.clear()
        updateSubmitButton()
        fetchGrants()
        fetchEligibleUsers()
        showToast(count > 1 ? `Access granted to ${count} members` : 'Access granted successfully', 'success')
      })
      .catch(err => {
        console.error('Failed to grant access', err)
        showToast(`Failed to grant access: ${err.message}`, 'error')
        updateSubmitButton()
      })
  }

  // Global Delegated Click Listener (Immune to Turbo page transitions)
  document.addEventListener('click', function (e) {
    // 1. Submit Grant button
    const submitBtn = e.target.closest('#share_grant_submit_btn')
    if (submitBtn) {
      e.preventDefault()
      executeGrant()
      return
    }

    // 2. Revoke Confirm button
    const revokeConfirmBtn = e.target.closest('#share_confirm_revoke_btn')
    if (revokeConfirmBtn) {
      e.preventDefault()
      executeRevoke()
      return
    }

    // 3. Select user card in Share with list
    const userCard = e.target.closest('.share-user-select-card')
    if (userCard) {
      e.preventDefault()
      const userId = parseInt(userCard.getAttribute('data-user-id'), 10)
      if (selectedUserIds.has(userId)) {
        selectedUserIds.delete(userId)
      } else {
        selectedUserIds.add(userId)
      }
      updateSubmitButton()
      renderEligibleUsers(cachedEligibleUsers)
      return
    }

    // 4. Revoke button on collaborator row
    const revokeBtn = e.target.closest('.share-revoke-btn')
    if (revokeBtn) {
      e.preventDefault()
      const grantId = revokeBtn.getAttribute('data-grant-id')
      const userName = revokeBtn.getAttribute('data-user-name') || 'this user'
      openRevokeModal(grantId, userName)
    }
  })
})()
